import { SaveCreditCardByToken } from '@/domain/usecases'
import { RemoteSaveCreditCardByToken } from '@/data/usecases'
import { makeAxiosHttpClient } from '@/main/factories/http'
import env from '@/main/config/env'

export const makeSaveCreditCardByToken = (): SaveCreditCardByToken => {
  const url = env.API_URL
  const httpClient = makeAxiosHttpClient<string>()

  return new RemoteSaveCreditCardByToken(url, httpClient)
}
